import { UsuarioPolicy } from "./UsuarioPolicy";

export const usuarioPolicy = new UsuarioPolicy()